<template>
  <div class="wrap">
    <div class="boxCard">
      <el-card class="box-card" :body-style="{padding: '0'}">
        <div slot="header" class="clearfix">
          <span>设备订单</span>
          <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
        </div>
        <el-form :inline="true" :model="queryParams" ref="queryParams" class="demo-form-inline">
          <el-form-item label="申请人" prop="memberName">
            <el-input v-model="queryParams.memberName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="pickupPhone">
            <el-input v-model="queryParams.pickupPhone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="申购设备" prop="configId">
            <el-select v-model="queryParams.configId" placeholder="请选择取货方式">
              <el-option v-for="(item, index) in deviceCfgList" :key="index" :label="item.hardwareName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="hardwareStatus">
            <el-select v-model="queryParams.hardwareStatus" placeholder="请选择取货方式">
              <el-option label="全部" value=""></el-option>
              <el-option label="待处理" value="1"></el-option>
              <el-option label="已处理" value="2"></el-option>
              <el-option label="已取消" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryDeviceList()">查询</el-button>
            <el-button @click="resetForm('queryParams')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div class="boxCard tabBox">
      <el-card class="box-card" :body-style="{padding: '0'}">
        <div slot="header">
          <span class="tabTitle">设备订单列表</span>
          <!-- <el-button type="primary" @click="showDialog('1')" class="addOrder">新增订单</el-button> -->
        </div>
        <el-table :data="deviceList" show-header border style="width: 100%">
          <el-table-column type="index" align="center" label="序号" />
          <el-table-column prop="memberName" align="center" label="会员姓名" />
          <el-table-column prop="pickupPerson" align="center" label="收货人" />
          <el-table-column prop="pickupPhone" align="center" label="联系电话" />
          <!-- <template slot-scope="scope">{{(scope.row.receiverPerson ||'').replace(/,/g,'')}}</template>
                    </el-table-column> -->
          <el-table-column prop="addressName" align="center" label="所在地区" />
          <el-table-column prop="hardwareName" align="center" label="申购设备" />
          <el-table-column prop="hardwareCount" align="center" label="申购数量" />
          <el-table-column prop="hardwarePrice" align="center" label="订单金额（元）" />
          <el-table-column prop="remark" align="center" label="备注" />
          <el-table-column prop="hardwareStatus" :formatter="hardwareStatusFormat" align="center" label="状态">
            <template slot-scope="scope">
              <el-tag :type="getStatus(scope.row.hardwareStatus)">{{ hardwareStatusFormat(scope.row.hardwareStatus) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" v-if="scope.row.hardwareStatus !== 3" @click="setOrder(scope.row)">处理</el-button>
              <el-button size="mini" type="danger" v-if="scope.row.hardwareStatus !== 3" @click="cancelOrder(scope.row.id, 3)">取消</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="pageNum" :page-size="pageSize" @size-change="barSizeChange" @current-change="barCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background="" layout="sizes, prev, pager, next" :total="totalCount"></el-pagination>
      </el-card>
    </div>
    <my-from-dialog :isShow="isShow" :title="'处理订单'" @cancel="closePup" @ok="closePup('ok')" @closeCallBack="closePup" :cancelText="'取消'" :okBtnText="'确认'">
      <template slot="froms">
        <el-form :model="form" :rules="rules" ref="form" label-width="140px">
          <el-form-item label="设备名称">{{ form.hardwareName }}</el-form-item>
          <el-form-item label="申购数量" prop="hardwareCount">
            <el-input-number v-model="form.hardwareCount" :min="1" :max="999"></el-input-number>
          </el-form-item>
          <el-form-item label="订单金额" prop="hardwarePrice">
            <el-input v-model="form.hardwarePrice" placeholder="请输入订单金额" class="baseInp" @keyup.native="InputNumber('hardwarePrice')"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="form.remark" type="textarea" placeholder="请输入订单金额" class="baseInp"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </my-from-dialog>
  </div>
</template>

<script>
import myFromDialog from '@/components/common/from_dialog';
import { objDeepCopy, resDecPoint } from '@/utils/index';
let self = null;
export default {
  components: {
    myFromDialog
  },
  computed: {},
  watch: {},
  created() {
    this.loginData = JSON.parse(localStorage.getItem('loginData')) || {};
    self = this;
    this.getDeviceCfgList();
    this.getDeviceList();
  },
  data() {
    return {
      isShow: false, // 是否显示处理订单弹窗
      pageNum: 1, // 当前页
      pageSize: 10, // 单页条数
      totalCount: 0, // 总页数
      queryParams: { memberName: '', pickupPhone: '', configId: '', hardwareStatus: '' }, // 请求参数
      form: {}, // 表单字段
      loginData: {}, // 登录返回的参数
      deviceList: [], // 设备订单列表
      deviceCfgList: [], // 设配下拉列表
      rules: this.getRules() // 校验
    }
  },
  methods: {
    //  关闭弹窗
    closePup(state) { // ok
      if (state !== 'ok') {
        self.isShow = false;
      } else {
        self.setOrderSql();
        console.log('ok');
      };
    },
    // 重置查询字段
    resetForm(formName) {
      self.$refs[formName].resetFields();
      self.getDeviceList();
    },
    // 点击查询
    queryDeviceList() {
      self.pageNum = 1;
      self.getDeviceList();
    },
    // 当前显示条数
    barSizeChange(val) {
      self.pageSize = val;
      self.getDeviceList();
    },
    // 当前页
    barCurrentChange(val) {
      self.pageNum = val;
      self.getDeviceList();
    },
    // 获取设备列表配置
    getDeviceCfgList() {
      self.$https.get('system/hardwareConfig/getHardwareConfigList', {}).then(res => {
        if (res.code === 200) {
          self.deviceCfgList = res.data || [];
        }
        console.log('设备列表=======》', res.data);
      }).catch(res => {
        // self.$message.error(res.data.msg || '接口请求异常');
      })
    },
    // 获取设备申请列表
    getDeviceList() {
      let queryParams = this.queryParams;
      let params = {
        memberName: queryParams.memberName,
        pickupPerson: queryParams.pickupPerson,
        pickupPhone: queryParams.pickupPhone,
        configId: queryParams.configId,
        hardwareStatus: queryParams.hardwareStatus,
        needComPms: true,
        pageNum: self.pageNum,
        pageSize: self.pageSize
      }
      self.$https.post('system/hardwareApplication/getHardwareApplicationPageList', params).then(res => {
        if (res.code === 200) {
          self.deviceList = res.rows || [];
          self.totalCount = res.total || 0;
        }
        console.log('设备订单列表=======》', res.rows);
      }).catch(res => {
        // self.$message.error(res.data.msg || '接口请求异常');
      })
    },
    // 取消订单
    cancelOrder(id, state) {
      self.$confirm('是否确定取消该订单?', '警告', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        self.cancelSql(id, state);
      });
    },
    cancelSql(id, state) { // 申请状态(1-待处理 2-已处理 3-已取消)
      self.$https.get('system/hardwareApplication/updateApplicationStatus', { status: state, id: id }).then(res => {
        if (res.code === 200) {
          self.$message.success('订单状态修改成功！');
          self.getDeviceList();
        }
        console.log('取消订单成功=======》', res);
      }).catch(res => {
        // self.$message.error(res.data.msg || '接口请求异常');
      })
    },
    // 设置订单
    setOrder(item) {
      self.isShow = true;
      self.form = {};
      self.form = Object.assign({}, item);
    },
    setOrderSql() {
      let params = {
        id: self.form.id,
        hardwareName: self.form.hardwareName,
        hardwareCount: self.form.hardwareCount,
        hardwarePrice: self.form.hardwarePrice,
        remark: self.form.remark
      }
      self.$https.post('system/hardwareApplication/updateHardwareApplication', params).then(res => {
        if (res.code === 200) {
          self.$message.success('处理订单成功！');
          self.isShow = false;
          self.cancelSql(params.id, 2);
        }
        console.log('处理订单成功=======》', res);
      }).catch(res => {
        // self.$message.error(res.data.msg || '接口请求异常');
      })
    },
    // 订单状态过滤
    hardwareStatusFormat(status) {
      return {
        '1': '待处理',
        '2': '已处理',
        '3': '已取消'
      }[status + ''] || '-';
    },
    // 订单状态字体颜色
    getStatus(status) {
      return {
        '1': 'info',
        '2': 'success',
        '3': 'danger'
      }[status + ''] || '-';
    },
    // 校验规则
    getRules() {
      return {
        hardwareCount: [{ required: true, message: '请输入申购数量', trigger: 'blur' }, { type: 'number', message: '请输入数字类型', trigger: 'blur' }],
        hardwarePrice: [{ required: true, message: '请输入订单金额', trigger: 'blur' }]
      }
    },
    // 限制输入框只能输入金额
    InputNumber(property) {
      self.form[property] = resDecPoint(this.form[property])
    }
  },
}
</script>

<style lang="less" scoped>
.wrap {
}
.boxCard {
    margin-bottom: 20px;
}
.queryBox {
    padding: 20px;
}
.baseInp {
    width: 300px;
}
.dlRole {
    margin-bottom: 10px;
    span {
        color: red;
    }
}

.tabTitle {
    display: inline-block;
    margin-right: 30px;
    padding: 20px 20px;
    font-size: 15px;
    font-weight: bold;
    color: #333;
}

.tabBox /deep/ .el-card__header {
    padding: 0;
}
.tabBox /deep/ .el-tabs__header {
    margin: 10px 20px 0;
}
.tabBox /deep/ .el-tabs__nav-wrap::after {
    background-color: transparent;
}

.input-all.el-icon-arrow-down:before,
.input-all.el-icon-arrow-up:before {
    position: absolute;
    right: 5px;
    top: 50%;
    z-index: 100;
    transform: translate(0, -50%);
}
.addOrder {
    display: block;
    margin: 10px;
}
.myDivider /deep/ .el-divider--horizontal {
    height: 3px;
}
.myDivider /deep/ .el-divider__text {
    font-weight: bold;
    font-size: 16px;
}
.myDivider {
    .state {
        margin-left: 50px;
        font-size: 14px;
        color: red;
    }
}
</style>
